export const CHECK_SHIPMENT_STATUS_RETRIES = 5
export const CHECK_SHIPMENT_STATUS_INTERVAL = 2000
